import { ClayTooltipProvider } from "@clayui/tooltip";
import ClayIcon from "@clayui/icon";
import { getShortText, getPersonas, getTooltipPersona } from "../../utils/util";
import { OBJECT_ENTRY_URL_SEPARATOR } from "../../utils/constants";
import { useEffect } from "react";

const LandingPageCard = ({ educationResourceItem, setCompletedCourses, t, type, userCompleteEnrollments, userInProgressEnrollments }) => {
	const description = getShortText(educationResourceItem.description || "", 150);
	const personas = getPersonas(educationResourceItem.audience || educationResourceItem.persona);
	const title = educationResourceItem.title || educationResourceItem.name;
	const tooltip = getTooltipPersona(educationResourceItem.audience || educationResourceItem.persona);

	function getCourseIdsArray(coursesData) {
		if (!Array.isArray(coursesData)) {
		  return [];
		}
		return coursesData.map(course => course.id);
	}

	function getResourceUrl(type) {
		switch (type) {
			case 'course':
				return OBJECT_ENTRY_URL_SEPARATOR.LESSON;
			case 'learningPath':
				return OBJECT_ENTRY_URL_SEPARATOR.LEARNING_PATH;
			case 'certification':
				return OBJECT_ENTRY_URL_SEPARATOR.CERTIFICATION;
			default:
				return 'l';
		}
	}

	useEffect(() => {
		setCompletedCourses(getCourseIdsArray(userCompleteEnrollments));
	}, [userCompleteEnrollments, setCompletedCourses]);

	return (
		<>
			<div className={`tag-${type}`}>{t(type)}</div>
			<a
				href={`/${getResourceUrl(type)}/${type === "course" ? educationResourceItem.firstLessonFriendlyUrlPath : educationResourceItem.id}`}
				className="card-link"
			>
				<div className="card-container d-flex learn-education__landing-card">
					<div className="card-content-container d-flex flex-column justify-content-between">
						<h4>{title}</h4>
						<div className="card-description">{description}</div>
						<div className="card-tags-container d-flex  learn-education">
							{type === "course" && (
								<>
									{getCourseIdsArray(userCompleteEnrollments).includes(educationResourceItem.id) && (
										<div className="align-self-start card-tag__completed card-tag__status">
											<span>
												{t("completed")}{" "}
												<ClayIcon className="ml-2" symbol="check" />
											</span>
										</div>
									)}

									{getCourseIdsArray(userInProgressEnrollments).includes(educationResourceItem.id) &&
										!getCourseIdsArray(userCompleteEnrollments).includes(educationResourceItem.id) && (
											<div className="align-self-start card-tag__status card-tag__inprogress">
												<span>{t("in-progress")}</span>
											</div>
										)}
								</>
							)}
							<div className="card-tags__persona__expertiseLevel">
								<ClayTooltipProvider>
									<div
										className="card-tag card-tag__persona"
										data-tool-tip-align="top"
										title={tooltip}
									>
										<p></p>
										<span>{personas}</span>
									</div>
								</ClayTooltipProvider>

								{educationResourceItem.expertiseLevel && (
									<div className={`card-tag card-tag__expertise-${educationResourceItem.expertiseLevel.name.toLowerCase()}`}>
										<p>{educationResourceItem.expertiseLevel.name}</p>
									</div>
								)}
							</div>
						</div>
					</div>
				</div>
			</a>
		</>
	);
};

export default LandingPageCard;
